import React, { useEffect, useState } from 'react';
import { Button, Row, Col, Modal, Tooltip, OverlayTrigger, Accordion, Card } from 'react-bootstrap'
import AuthService from "../controllers/AuthService";
import UserService from "../controllers/UserService";
import MultiCarouselPage from './MultiCarouselPage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import $ from 'jquery'



const ReportStudentEvaluateTeacher = props => {

    const [name, setName] = useState('');
    const [headline, setHeadline] = useState('ผลประเมินจากมุมมองของนักเรียน');
    const [description, setDescription] = useState('');
    const [question, setQuestion] = useState('อุปนิสัยเชิงบวกของคุณครูในมุมมองของนักเรียน');
    const [questionTextBox, setQuestionTextBox] = useState('ความคิดเห็นในมุมมองของนักเรียนที่มีต่อคุณครู');
    const [notDone, setNotDone] = useState('d-none');
    const [isDone, setIsDone] = useState('d-none');
    const [data1, setData1] = useState([]);
    const [data2, setData2] = useState([]);
    const [textReview, setTextReview] = useState([]);
    const [rId, setRId] = useState('');
    const [uId, setUId] = useState('');
    const [strengths, setStrengths] = useState([]);
    const [countStudent, setCountStudent] = useState([]);

    const responsive3 = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3,
            // partialVisibilityGutter: 40 // this is needed to tell the amount of px that should be visible.
        },
        tablet: {
            breakpoint: { max: 1024, min: 500 },
            items: 2,
            partialVisibilityGutter: 100 // this is needed to tell the amount of px that should be visible.
        },
        mobile: {
            breakpoint: { max: 500, min: 0 },
            items: 1,
            partialVisibilityGutter: 100 // this is needed to tell the amount of px that should be visible.
        }
    }
    const responsive2 = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3,
            partialVisibilityGutter: 40 // this is needed to tell the amount of px that should be visible.
        },
        tablet: {
            breakpoint: { max: 1024, min: 500 },
            items: 2,
            partialVisibilityGutter: 100 // this is needed to tell the amount of px that should be visible.
        },
        mobile: {
            breakpoint: { max: 500, min: 0 },
            items: 1,
            partialVisibilityGutter: 100 // this is needed to tell the amount of px that should be visible.
        }
    }


    useEffect(() => {


        // const userId = AuthService.getCurrentUser().id

        const userId = props.teacherId; // handle headmaster 
        const roomId = props.roomId;
        setRId(roomId)
        setUId(userId)
        let doneStatus = false;
        let newStrengths = []
        var allStudentAnswer = 0;
        var user = AuthService.getCurrentUser();
        //todo ปีการศึกษา        
        var filter = {};


        UserService.getRoomDetail(roomId).then((response) => {
            filter = {
                "domain": user.domain.name,
                "roomId": roomId,
                "year": response.data.data.year,
                "term": response.data.data.term,
            };
        }).then(() => {

            UserService.getStrengths().then((response) => {
                setStrengths(response.data.data)

                for (const [index, str] of response.data.data.entries()) {
                    newStrengths[str.id] = {
                        image: str.imageUrl,
                        name: str.name,
                        description: str.description
                    }
                }
                // setReStrengths(newStrengths)
                return response.data.data
            }).then((apiStrengths) => {
                UserService.getFriendShipList(userId, filter).then(
                    (res) => {
                        //    console.log('test-naju');
                        //    console.log(res);
                        var images0 = [];
                        var stringHtml;
                        var allAnswer0 = [];
                        var selfText = [];
                        var text0 = [];

                        if (res.data.data && res.data.data[0] && res.data.data[0].others) {

                            console.log(res.data.data[0].others);
                            for (const [index, aAnswer] of res.data.data[0].others.entries()) {

                                if (aAnswer.user.roles[0].toLowerCase() !== 'teacher' && aAnswer.answerAt !== null) {

                                    if (userId !== aAnswer.user.id) {
                                        //student Evaluate         
                                        doneStatus = true;
                                        if (allAnswer0[aAnswer.answers[0].values[0]]) {
                                            allStudentAnswer++;
                                            allAnswer0[aAnswer.answers[0].values[0]] += 1;
                                        } else {
                                            allStudentAnswer++;
                                            allAnswer0[aAnswer.answers[0].values[0]] = 1;
                                        }

                                        if (allAnswer0[aAnswer.answers[1].values[0]]) {
                                            allAnswer0[aAnswer.answers[1].values[0]] += 1;
                                        } else {

                                            allAnswer0[aAnswer.answers[1].values[0]] = 1;
                                        }

                                        if (allAnswer0[aAnswer.answers[2].values[0]]) {
                                            allAnswer0[aAnswer.answers[2].values[0]] += 1;
                                        } else {

                                            allAnswer0[aAnswer.answers[2].values[0]] = 1;
                                        }


                                        selfText.push(aAnswer.answers[3].values[0]);

                                    }
                                }
                            }

                            var myArr0 = Object.fromEntries(
                                Object.entries(allAnswer0).sort(([, a], [, b]) => b - a)
                            );

                            Object.keys(myArr0).map((aArray, i) => {
                                // tempPercent = res.data.data.percentages[aArray]
                                if (allAnswer0[aArray] <= 1) {
                                    stringHtml = `<div class="primary-text percent-font" data-value="1"><img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100  cardimage i0${aArray}" />`;
                                } else {
                                    stringHtml = `<div class="primary-text percent-font" data-value="1"><button type="button" class="btnin-card btn font-sarabun-bold"><img src='/images/evaluate/card_icon.png' class="mr-1 img-cardicon"/> ${allAnswer0[aArray]}</button><img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100  cardimage i0${aArray}" />`;

                                }
                                let headline = ['อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา',
                                    'อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา',
                                    'อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา'
                                ]
                                var temp = <div dangerouslySetInnerHTML={{ __html: stringHtml }} className="anywhere-wrap d-relative carousel-div" key="i0-${i}" onClick={() => { cardClick(aArray, '.tab0', newStrengths[aArray], '.i0' + aArray, headline[i]) }} />
                                images0.push(temp);
                            })


                            Object.keys(selfText).map((aArray2, i) => {

                                stringHtml = `<div class="box-text border-radius-12 border-blue p-3 text-left overflow-7 div-ans auto-height" data-value="1"> ${selfText[aArray2]}</div>`;
                                var temp = <div dangerouslySetInnerHTML={{ __html: stringHtml }} className="anywhere-wrap d-relative carousel-div" key="t0-${i}" />
                                text0.push(temp);

                            })
                            setTextReview(selfText);
                        }


                        console.log('images0');
                        console.log([images0], [text0]);


                        return [[images0], [text0]];

                    }).then((res) => {
                        setData1(res[0]);
                        setData2(res[1]);
                        setCountStudent(allStudentAnswer);
                        if (doneStatus) {
                            setIsDone('');
                            setNotDone('d-none');
                        } else {
                            setIsDone('d-none');
                            setNotDone('');
                        }
                    }).then((res) => {
                        // myloop();            
                    })
            });
        })

    }, [])


    const goto = (target, newTab = false) => {
        if (target && newTab) {
            window.open(target, '_blank').focus();
        }
    }

    return (
        <div>
            <div className={notDone}>
                <Row>
                    <Col xs={12} className="text-center">ยังไม่ได้ทำประเมิน</Col>
                </Row>
            </div>
            <div className={isDone}>
                <Row className="bg-light-blue">
                    <Col xs={12} md={12} className="w-100 text-center pt-4 ">
                        <h2 class="font-sarabun-bold primary-text " >{headline}</h2>
                    </Col>
                </Row>
                <Row style={{ "paddingBottom": "17px" }} className="bg-light-blue">
                    <Col className="main-evaluate-overview pb-3">
                        <Row>
                            <Col xs={12} md={12} className="w-100 m-center-d-left pt-3">
                                <h4 class="font-sarabun-bold text-left">{description}</h4>
                            </Col>
                            <Col xs={12} md={12} className="w-100 text-center pt-3">
                                <Button className="bluesky d-inline py-1 py-md-2 px-4 bt font-sarabun-bold btn btn-primary export-btn m-auto"  >
                                    <h5 className="mb-0 font-weight-bold" onClick={() => goto(`/report/friendship/export/student-evaluate-teacher/${rId}/${uId}`, true)}>Export</h5>
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col className="main-evaluate-overview text-left ">
                        <h4 class="font-sarabun-bold text--gray py-3"><img src='/images/evaluate/ppl.png' class="pb-2 pr-2" />ประเมินครูแล้ว {countStudent} คน</h4>
                    </Col>
                </Row>

                <Row className="pt-3 pb-5 report-tab">
                    <Col className="main-evaluate-overview">
                        <Row>
                            <Col>
                                <h4 class="font-sarabun-bold"><img src='/images/evaluate/search.png' class="evaluate-search" /> {question}</h4>
                            </Col>
                        </Row>
                        <Row className="bg-white mx-0">
                            <Col className="px-0">
                                <MultiCarouselPage data={data1} responsive={data1.length > 3 ? responsive2 : responsive3} />
                            </Col>
                        </Row>
                        <Row className="py-3 bg-white mx-0 tab0 tab">
                        </Row>

                        <Row>
                            <Col className="w-100 px-4">
                                <h4 class="font-sarabun-bold text-center pt-3"><img src='/images/evaluate/comment.png' class="pr-2" />{questionTextBox}</h4>
                                <MultiCarouselPage data={data2} responsive={data2.length > 3 ? responsive2 : responsive3} />
                            </Col>
                        </Row>
                        {/* <Row>
                            <Col className="w-100 px-4 pt-1">                               
                                <div className='border-radius-12 border-blue p-3 text-left overflow-7 div-ans auto-height'>
                                    <div className='font-sarabun'>{ textReview }</div>
                                </div>
                            </Col>
                        </Row>                    */}
                    </Col>
                </Row>

            </div>
        </div>
    )


    function cardClick(key, tab, str, ele, headline = '') {

        $('.tab').html('');


        // if($('body').find(ele).hasClass( "border-card")){              
        $('body').find('.cardimage').removeClass("border-card");
        // };
        if (headline) {
            headline = `<h5 class="font-sarabun-bold font-default">${headline}</h5>`
        }
        $('body').find(ele).addClass("border-card");
        $(tab).html('<div class="str-div">' + headline + '<h5 class="font-sarabun-bold">' + str.name + '</h5><h6>' + str.description + '</h6></div>');

    }
}

export default ReportStudentEvaluateTeacher